// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "components/" + {"440":"8f83466c2fcd42e2bfec","4228":"a2225e21d336def4386d"}[chunkId] + ".js";
};